import { ArrowDown } from "lucide-react";

/**
 * Sticky "jump to latest" affordance.
 *
 * Pairs with `useChatAutoscroll`: once the reader scrolls up, follow mode suspends and this appears
 * so returning to the live end of the conversation is one click rather than a long scroll. While a
 * turn is streaming it says so, which is the difference between "I moved away" and "something new
 * happened while I was away".
 *
 * The row spans the full column because `position: sticky` needs a normal-flow block; it is
 * pointer-transparent so the conversation underneath stays clickable.
 */
export function JumpToLatest({
	visible,
	streaming,
	onClick,
}: {
	visible: boolean;
	streaming: boolean;
	onClick: () => void;
}) {
	if (!visible) return null;
	return (
		<div className="pointer-events-none sticky bottom-3 z-10 flex shrink-0 justify-end pr-3">
			<button
				type="button"
				onClick={onClick}
				aria-label={streaming ? "Jump to the latest activity" : "Jump to the latest message"}
				className="tst-interactive pointer-events-auto inline-flex h-8 items-center gap-1.5 rounded-full border border-border bg-card px-3 text-[11px] font-medium text-muted-foreground shadow-md hover:text-foreground"
			>
				<ArrowDown className="h-3.5 w-3.5 shrink-0" />
				{streaming ? "New activity" : "Latest"}
			</button>
		</div>
	);
}
